import { lazy, Suspense } from 'react'

import { createFileRoute } from '@tanstack/react-router'

import { RouteErrorComponent } from '@/features/app-shell/route-error-component'
import { SectionDescription, SectionTitle } from '@/features/app-shell/section'
import { IntegrationsListSkeleton } from '@/features/integrations/components/skeletons'
import { integrationQueries } from '@/features/integrations/queries'

import { getCurrentTenant } from '@/shared/auth/store'

import { ErrorBoundary } from '@/components/common/error-boundary'

const IntegrationsList = lazy(
	() => import('@/features/integrations/components/list'),
)

export const Route = createFileRoute('/_dashboard/integrations/cloud/')({
	loader: ({ context: { queryClient } }) => {
		const tenant = getCurrentTenant() as string

		if (tenant) {
			// The list derives its enriched rows from these two queries.
			queryClient.prefetchQuery(integrationQueries.list(tenant))
			queryClient.prefetchQuery(integrationQueries.available(tenant))
		}
	},

	head: () => ({
		meta: [
			{
				title: 'Integrations | BitLyft AIR®',
			},
		],
	}),

	component: IntegrationsHomePage,
	pendingComponent: IntegrationsLoadingPage,
	errorComponent: RouteErrorComponent,
})

function IntegrationsHomePage() {
	return (
		<>
			<SectionTitle>Integrations</SectionTitle>
			<SectionDescription>
				Cloud services connected to AIR® over API. Add pulls from the catalog.
			</SectionDescription>

			<ErrorBoundary>
				<Suspense fallback={<IntegrationsListSkeleton />}>
					<IntegrationsList />
				</Suspense>
			</ErrorBoundary>
		</>
	)
}

function IntegrationsLoadingPage() {
	return (
		<>
			<SectionTitle>Integrations</SectionTitle>
			<SectionDescription>
				Cloud services connected to AIR® over API. Add pulls from the catalog.
			</SectionDescription>

			<IntegrationsListSkeleton />
		</>
	)
}
